export interface CurrencyOption {
  code: string
  name: string
}

export const DEFAULT_CURRENCY = 'CAD'

const commonCodes = ['CAD', 'USD', 'EUR', 'GBP', 'AUD', 'JPY']
const displayNames = new Intl.DisplayNames(undefined, { type: 'currency' })

export const CURRENCIES: CurrencyOption[] = commonCodes.map((code) => ({
  code,
  name: displayNames.of(code) ?? code,
}))

export function currencyOptions(current?: string | null): CurrencyOption[] {
  if (!current || CURRENCIES.some((currency) => currency.code === current)) {
    return CURRENCIES
  }
  // Keep older custom values visible when an existing product is edited.
  return [{ code: current, name: current }, ...CURRENCIES]
}
